async function browserIsFirefox() {
    // Catches all Gecko based, as they seem to add their own name after 'Firefox'
    // Like Gecko/20100101 Firefox/30.0 Iceweasel/30.0
    // This is probably okay
    const isGecko = /.*Gecko.*Firefox.*/.test(navigator.userAgent);
    return isGecko;
}
export default browserIsFirefox;
//# sourceMappingURL=is-firefox.js.map